<!-- 
	This is the main page of the application, the layout component is used here,
	and the router-view is passed to it.
	Layout component is dynamically declared based on the layout for each route,
	specified in routes list router/index.js .
 -->

<template>
	<div id="app">
        <loading
            :active="isLoading"
            :can-cancel="false"
            :is-full-page="true"
            background-color="black"
            :opacity="0.1"
        />

        <a-spin tip="Loading..." :spinning="loading()">
          <component :is="layout">
            <router-view />
          </component>
        </a-spin>
	</div>
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'

	export default ({
        components: {
            Loading
        },
		computed: {
			// Sets components name based on current route's specified layout, defaults to
			// <layout-default></layout-default> component.
			layout() {
				return "layout-" + ( this.$route.meta.layout || "default" ).toLowerCase() ;
			},

            isLoading() {
                return this.$store.getters["global/isLoading"]
            }
		},
    	methods: {
			loading(){
				return this.$loading;
			}
		},
	})
	
</script>

<style lang="scss">

.no-shadow {
    box-shadow: none !important;
}

.ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 12px 8px !important;
}

.ant-table-body {
    padding: 0 15px !important;
}

</style>